import { withInstall } from "../utils";
import _Progress from "./Progress";
var Progress = withInstall(_Progress);
var stdin_default = Progress;
export { Progress, stdin_default as default };